import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';

const RefundPolicy = () => {
    return (
        <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 10 }}>
            <Container maxWidth="md">
                <Typography variant="h3" sx={{ fontWeight: 900, mb: 6 }}>Refund Policy</Typography>
                <Stack spacing={4} sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>1. Subscription Refunds</Typography>
                        <Typography variant="body1">
                            We offer a 7-day refund window for first-time paid subscriptions. If you are not satisfied
                            with the service within 7 days of your initial subscription purchase, you may request a full
                            refund by contacting support@socialixer.com. Refund requests made after the 7-day window will
                            not be honoured.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>2. Renewal Charges</Typography>
                        <Typography variant="body1">
                            Subscription renewals are non-refundable. You are responsible for cancelling your subscription
                            before the next billing cycle to avoid renewal charges. Please refer to our Cancellation Policy
                            for details on how to cancel.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>3. Top-up Credits and AI Usage</Typography>
                        <Typography variant="body1">
                            One-time top-up credit purchases are non-refundable once the transaction has completed.
                            AI usage that has already been consumed against your plan quota or top-up balance cannot be
                            refunded. Top-up credits do not expire and remain available on your account.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>4. Payment Processing Errors</Typography>
                        <Typography variant="body1">
                            If you were charged in error, charged twice for the same transaction, or charged after
                            cancelling your subscription, please contact support@socialixer.com within 30 days of the
                            charge. We will investigate and issue a full refund for any verified payment processing errors.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>5. How to Request a Refund</Typography>
                        <Typography variant="body1">
                            To request a refund, email support@socialixer.com from the email address associated with your
                            account, including your transaction ID and the reason for the request. Approved refunds will
                            be issued to the original payment method within 5–10 business days, depending on your bank
                            or payment provider.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>6. Contact</Typography>
                        <Typography variant="body1">
                            For any questions about this Refund Policy, contact us at support@socialixer.com.
                        </Typography>
                    </Box>
                </Stack>
            </Container>
        </Box>
    );
};

export default RefundPolicy;
